import { fontSets } from './fontSets';

const fontSetMapping = {
  1: 'corporate',
  2: 'modern',
};

export const getGlobalTheme = (theme) => {
  const selectedFontSet = fontSetMapping[theme?.typography?.fontSet] || 'corporate';

  const themeObj = {
    breakpoints: {
      aa: 375,
      a: 480,
      b: 800,
      ba: 1040,
      c: 1200,
      d: 1400,
    },
    colours: {
      text: {
        heading: theme?.colours?.text?.heading ? theme.colours.text.heading : '#193460',
        primary: theme?.colours?.text?.primary ? theme.colours.text.primary : '#3D4850',
        secondary: theme?.colours?.text?.secondary ? theme.colours.text.secondary : '#757C83',
        tertiary: theme?.colours?.text?.tertiary ? theme.colours.text.tertiary : '#95ABBB',
        reverse: theme?.colours?.text?.reverse ? theme.colours.text.reverse : '#FFFFFF',
        sharedFooter: theme?.colours?.text?.sharedFooter
          ? theme.colours.text.sharedFooter
          : '#FFFFFF',
      },
      link: {
        default: theme?.colours?.link?.default ? theme.colours.link.default : '#006EA9',
        rollover: theme?.colours?.link?.rollover ? theme.colours.link.rollover : '#F16241',
        nav: theme?.colours?.link?.nav ? theme?.colours?.link?.nav : '#193460',
        underline: theme?.colours?.link?.underline
          ? theme?.colours?.link?.underline
          : 'transparent',
      },
      button: {
        primary: {
          text: theme?.colours?.button?.primary?.text
            ? theme.colours.button.primary.text
            : '#FFFFFF',
          background: theme?.colours?.button?.primary?.background
            ? theme.colours.button.primary.background
            : '#006EA9',
        },
        secondary: {
          text: theme?.colours?.button?.secondary?.text
            ? theme.colours.button.secondary.text
            : '#006EA9',
          background: theme?.colours?.button?.secondary?.background
            ? theme.colours.button.secondary.background
            : '#DFE5EA',
        },
      },
      brand: {
        a: theme?.colours?.brand?.a ? theme.colours.brand.a : '#193460',
        b: theme?.colours?.brand?.b ? theme.colours.brand.b : '#93ABBB',
      },
      background: {
        a: theme?.colours?.background?.a ? theme.colours.background.a : '#FFFFFF',
        b: theme?.colours?.background?.b ? theme.colours.background.b : '#F9FBFB',
        c: theme?.colours?.background?.c ? theme.colours.background.c : '#F3F5F7',
        navA: theme?.colours?.background?.navA ? theme.colours.background.navA : '#193460',
        navB: theme?.colours?.background?.navB ? theme.colours.background.navB : 'transparent',
      },
      accent: {
        keyline: theme?.colours?.accent?.keyline ? theme.colours.accent.keyline : '#DFE5EA',
        icon: theme?.colours?.accent?.icon ? theme.colours.accent.icon : '#95ABBB',
      },
      status: {
        r: theme?.colours?.status?.r ? theme.colours.status.r : '#F16241',
        a: theme?.colours?.status?.a ? theme.colours.status.a : '#F7AE3F',
        g: theme?.colours?.status?.g ? theme.colours.status.g : '#B7C851',
      },
      overlay: {
        overlayOpacity: theme?.colours?.overlay?.overlayOpacity
          ? theme.colours.overlay.overlayOpacity
          : '50%',
        overlayColour: theme?.colours?.overlay?.overlayColour
          ? theme.colours.overlay.overlayColour
          : '#193460',
      },
    },
    typography: {
      fontFace: {
        desktop: {
          h1: fontSets[selectedFontSet]?.desktop?.fontFace?.h1,
          h2: fontSets[selectedFontSet]?.desktop?.fontFace?.h2,
          h3: fontSets[selectedFontSet]?.desktop?.fontFace?.h3,
          h4: fontSets[selectedFontSet]?.desktop?.fontFace?.h4,
          h5: fontSets[selectedFontSet]?.desktop?.fontFace?.h5,
          h6: fontSets[selectedFontSet]?.desktop?.fontFace?.h6,
          body: fontSets[selectedFontSet]?.desktop?.fontFace?.body,
          bodyBold: fontSets[selectedFontSet]?.desktop?.fontFace?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.desktop?.fontFace?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.desktop?.fontFace?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.desktop?.fontFace?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.desktop?.fontFace?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.desktop?.fontFace?.functional,
        },
        tablet: {
          h1: fontSets[selectedFontSet]?.tablet?.fontFace?.h1,
          h2: fontSets[selectedFontSet]?.tablet?.fontFace?.h2,
          h3: fontSets[selectedFontSet]?.tablet?.fontFace?.h3,
          h4: fontSets[selectedFontSet]?.tablet?.fontFace?.h4,
          h5: fontSets[selectedFontSet]?.tablet?.fontFace?.h5,
          h6: fontSets[selectedFontSet]?.tablet?.fontFace?.h6,
          body: fontSets[selectedFontSet]?.tablet?.fontFace?.body,
          bodyBold: fontSets[selectedFontSet]?.tablet?.fontFace?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.tablet?.fontFace?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.tablet?.fontFace?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.tablet?.fontFace?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.tablet?.fontFace?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.tablet?.fontFace?.functional,
        },
        mobile: {
          h1: fontSets[selectedFontSet]?.mobile?.fontFace?.h1,
          h2: fontSets[selectedFontSet]?.mobile?.fontFace?.h2,
          h3: fontSets[selectedFontSet]?.mobile?.fontFace?.h3,
          h4: fontSets[selectedFontSet]?.mobile?.fontFace?.h4,
          h5: fontSets[selectedFontSet]?.mobile?.fontFace?.h5,
          h6: fontSets[selectedFontSet]?.mobile?.fontFace?.h6,
          body: fontSets[selectedFontSet]?.mobile?.fontFace?.body,
          bodyBold: fontSets[selectedFontSet]?.mobile?.fontFace?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.mobile?.fontFace?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.mobile?.fontFace?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.mobile?.fontFace?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.mobile?.fontFace?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.mobile?.fontFace?.functional,
        },
      },
      fontSize: {
        desktop: {
          h1: fontSets[selectedFontSet]?.desktop?.fontSize?.h1,
          h2: fontSets[selectedFontSet]?.desktop?.fontSize?.h2,
          h3: fontSets[selectedFontSet]?.desktop?.fontSize?.h3,
          h4: fontSets[selectedFontSet]?.desktop?.fontSize?.h4,
          h5: fontSets[selectedFontSet]?.desktop?.fontSize?.h5,
          h6: fontSets[selectedFontSet]?.desktop?.fontSize?.h6,
          body: fontSets[selectedFontSet]?.desktop?.fontSize?.body,
          bodyBold: fontSets[selectedFontSet]?.desktop?.fontSize?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.desktop?.fontSize?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.desktop?.fontSize?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.desktop?.fontSize?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.desktop?.fontSize?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.desktop?.fontSize?.functional,
        },
        tablet: {
          h1: fontSets[selectedFontSet]?.tablet?.fontSize?.h1,
          h2: fontSets[selectedFontSet]?.tablet?.fontSize?.h2,
          h3: fontSets[selectedFontSet]?.tablet?.fontSize?.h3,
          h4: fontSets[selectedFontSet]?.tablet?.fontSize?.h4,
          h5: fontSets[selectedFontSet]?.tablet?.fontSize?.h5,
          h6: fontSets[selectedFontSet]?.tablet?.fontSize?.h6,
          body: fontSets[selectedFontSet]?.tablet?.fontSize?.body,
          bodyBold: fontSets[selectedFontSet]?.tablet?.fontSize?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.tablet?.fontSize?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.tablet?.fontSize?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.tablet?.fontSize?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.tablet?.fontSize?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.tablet?.fontSize?.functional,
        },
        mobile: {
          h1: fontSets[selectedFontSet]?.mobile?.fontSize?.h1,
          h2: fontSets[selectedFontSet]?.mobile?.fontSize?.h2,
          h3: fontSets[selectedFontSet]?.mobile?.fontSize?.h3,
          h4: fontSets[selectedFontSet]?.mobile?.fontSize?.h4,
          h5: fontSets[selectedFontSet]?.mobile?.fontSize?.h5,
          h6: fontSets[selectedFontSet]?.mobile?.fontSize?.h6,
          body: fontSets[selectedFontSet]?.mobile?.fontSize?.body,
          bodyBold: fontSets[selectedFontSet]?.mobile?.fontSize?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.mobile?.fontSize?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.mobile?.fontSize?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.mobile?.fontSize?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.mobile?.fontSize?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.mobile?.fontSize?.functional,
        },
      },
      lineHeight: {
        desktop: {
          h1: fontSets[selectedFontSet]?.desktop?.lineHeight?.h1,
          h2: fontSets[selectedFontSet]?.desktop?.lineHeight?.h2,
          h3: fontSets[selectedFontSet]?.desktop?.lineHeight?.h3,
          h4: fontSets[selectedFontSet]?.desktop?.lineHeight?.h4,
          h5: fontSets[selectedFontSet]?.desktop?.lineHeight?.h5,
          h6: fontSets[selectedFontSet]?.desktop?.lineHeight?.h6,
          body: fontSets[selectedFontSet]?.desktop?.lineHeight?.body,
          bodyBold: fontSets[selectedFontSet]?.desktop?.lineHeight?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.desktop?.lineHeight?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.desktop?.lineHeight?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.desktop?.lineHeight?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.desktop?.lineHeight?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.desktop?.lineHeight?.functional,
        },
        tablet: {
          h1: fontSets[selectedFontSet]?.tablet?.lineHeight?.h1,
          h2: fontSets[selectedFontSet]?.tablet?.lineHeight?.h2,
          h3: fontSets[selectedFontSet]?.tablet?.lineHeight?.h3,
          h4: fontSets[selectedFontSet]?.tablet?.lineHeight?.h4,
          h5: fontSets[selectedFontSet]?.tablet?.lineHeight?.h5,
          h6: fontSets[selectedFontSet]?.tablet?.lineHeight?.h6,
          body: fontSets[selectedFontSet]?.tablet?.lineHeight?.body,
          bodyBold: fontSets[selectedFontSet]?.tablet?.lineHeight?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.tablet?.lineHeight?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.tablet?.lineHeight?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.tablet?.lineHeight?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.tablet?.lineHeight?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.tablet?.lineHeight?.functional,
        },
        mobile: {
          h1: fontSets[selectedFontSet]?.mobile?.lineHeight?.h1,
          h2: fontSets[selectedFontSet]?.mobile?.lineHeight?.h2,
          h3: fontSets[selectedFontSet]?.mobile?.lineHeight?.h3,
          h4: fontSets[selectedFontSet]?.mobile?.lineHeight?.h4,
          h5: fontSets[selectedFontSet]?.mobile?.lineHeight?.h5,
          h6: fontSets[selectedFontSet]?.mobile?.lineHeight?.h6,
          body: fontSets[selectedFontSet]?.mobile?.lineHeight?.body,
          bodyBold: fontSets[selectedFontSet]?.mobile?.lineHeight?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.mobile?.lineHeight?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.mobile?.lineHeight?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.mobile?.lineHeight?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.mobile?.lineHeight?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.mobile?.lineHeight?.functional,
        },
      },
      fontWeight: {
        desktop: {
          h1: fontSets[selectedFontSet]?.desktop?.fontWeight?.h1,
          h2: fontSets[selectedFontSet]?.desktop?.fontWeight?.h2,
          h3: fontSets[selectedFontSet]?.desktop?.fontWeight?.h3,
          h4: fontSets[selectedFontSet]?.desktop?.fontWeight?.h4,
          h5: fontSets[selectedFontSet]?.desktop?.fontWeight?.h5,
          h6: fontSets[selectedFontSet]?.desktop?.fontWeight?.h6,
          body: fontSets[selectedFontSet]?.desktop?.fontWeight?.body,
          bodyBold: fontSets[selectedFontSet]?.desktop?.fontWeight?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.desktop?.fontWeight?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.desktop?.fontWeight?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.desktop?.fontWeight?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.desktop?.fontWeight?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.desktop?.fontWeight?.functional,
        },
        tablet: {
          h1: fontSets[selectedFontSet]?.tablet?.fontWeight?.h1,
          h2: fontSets[selectedFontSet]?.tablet?.fontWeight?.h2,
          h3: fontSets[selectedFontSet]?.tablet?.fontWeight?.h3,
          h4: fontSets[selectedFontSet]?.tablet?.fontWeight?.h4,
          h5: fontSets[selectedFontSet]?.tablet?.fontWeight?.h5,
          h6: fontSets[selectedFontSet]?.tablet?.fontWeight?.h6,
          body: fontSets[selectedFontSet]?.tablet?.fontWeight?.body,
          bodyBold: fontSets[selectedFontSet]?.tablet?.fontWeight?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.tablet?.fontWeight?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.tablet?.fontWeight?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.tablet?.fontWeight?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.tablet?.fontWeight?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.tablet?.fontWeight?.functional,
        },
        mobile: {
          h1: fontSets[selectedFontSet]?.mobile?.fontWeight?.h1,
          h2: fontSets[selectedFontSet]?.mobile?.fontWeight?.h2,
          h3: fontSets[selectedFontSet]?.mobile?.fontWeight?.h3,
          h4: fontSets[selectedFontSet]?.mobile?.fontWeight?.h4,
          h5: fontSets[selectedFontSet]?.mobile?.fontWeight?.h5,
          h6: fontSets[selectedFontSet]?.mobile?.fontWeight?.h6,
          body: fontSets[selectedFontSet]?.mobile?.fontWeight?.body,
          bodyBold: fontSets[selectedFontSet]?.mobile?.fontWeight?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.mobile?.fontWeight?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.mobile?.fontWeight?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.mobile?.fontWeight?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.mobile?.fontWeight?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.mobile?.fontWeight?.functional,
        },
      },
      letterSpacing: {
        desktop: {
          h1: fontSets[selectedFontSet]?.desktop?.letterSpacing?.h1,
          h2: fontSets[selectedFontSet]?.desktop?.letterSpacing?.h2,
          h3: fontSets[selectedFontSet]?.desktop?.letterSpacing?.h3,
          h4: fontSets[selectedFontSet]?.desktop?.letterSpacing?.h4,
          h5: fontSets[selectedFontSet]?.desktop?.letterSpacing?.h5,
          h6: fontSets[selectedFontSet]?.desktop?.letterSpacing?.h6,
          body: fontSets[selectedFontSet]?.desktop?.letterSpacing?.body,
          bodyBold: fontSets[selectedFontSet]?.desktop?.letterSpacing?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.desktop?.letterSpacing?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.desktop?.letterSpacing?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.desktop?.letterSpacing?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.desktop?.letterSpacing?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.desktop?.letterSpacing?.functional,
        },
        tablet: {
          h1: fontSets[selectedFontSet]?.tablet?.letterSpacing?.h1,
          h2: fontSets[selectedFontSet]?.tablet?.letterSpacing?.h2,
          h3: fontSets[selectedFontSet]?.tablet?.letterSpacing?.h3,
          h4: fontSets[selectedFontSet]?.tablet?.letterSpacing?.h4,
          h5: fontSets[selectedFontSet]?.tablet?.letterSpacing?.h5,
          h6: fontSets[selectedFontSet]?.tablet?.letterSpacing?.h6,
          body: fontSets[selectedFontSet]?.tablet?.letterSpacing?.body,
          bodyBold: fontSets[selectedFontSet]?.tablet?.letterSpacing?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.tablet?.letterSpacing?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.tablet?.letterSpacing?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.tablet?.letterSpacing?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.tablet?.letterSpacing?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.tablet?.letterSpacing?.functional,
        },
        mobile: {
          h1: fontSets[selectedFontSet]?.mobile?.letterSpacing?.h1,
          h2: fontSets[selectedFontSet]?.mobile?.letterSpacing?.h2,
          h3: fontSets[selectedFontSet]?.mobile?.letterSpacing?.h3,
          h4: fontSets[selectedFontSet]?.mobile?.letterSpacing?.h4,
          h5: fontSets[selectedFontSet]?.mobile?.letterSpacing?.h5,
          h6: fontSets[selectedFontSet]?.mobile?.letterSpacing?.h6,
          body: fontSets[selectedFontSet]?.mobile?.letterSpacing?.body,
          bodyBold: fontSets[selectedFontSet]?.mobile?.letterSpacing?.bodyBold,
          bodyLarge: fontSets[selectedFontSet]?.mobile?.letterSpacing?.bodyLarge,
          bodySmall: fontSets[selectedFontSet]?.mobile?.letterSpacing?.bodySmall,
          blockquote: fontSets[selectedFontSet]?.mobile?.letterSpacing?.blockquote,
          blockquoteBold: fontSets[selectedFontSet]?.mobile?.letterSpacing?.blockquoteBold,
          functional: fontSets[selectedFontSet]?.mobile?.letterSpacing?.functional,
        },
      },
      transform: {
        h1: theme?.typography?.transform?.h1 ? theme.typography.transform.h1 : 'uppercase',
        h2: theme?.typography?.transform?.h2 ? theme.typography.transform.h2 : 'uppercase',
        h3: theme?.typography?.transform?.h3 ? theme.typography.transform.h3 : 'uppercase',
        h4: theme?.typography?.transform?.h4 ? theme.typography.transform.h4 : 'normal',
        h5: theme?.typography?.transform?.h5 ? theme.typography.transform.h5 : 'normal',
        h6: theme?.typography?.transform?.h6 ? theme.typography.transform.h6 : 'normal',
        functional: theme?.typography?.transform?.functional
          ? theme.typography.transform.functional
          : 'uppercase',
      },
    },
    iconography: {
      set: theme?.iconography?.set ? theme.iconography.set : 'a',
      lightIcons: theme?.iconography?.lightIcons ? theme?.iconography?.lightIcons : false,
    },
    spacing: {
      outer: {
        small: theme?.spacing?.outer?.small ? theme.spacing.outer.small : '0px',
        medium: theme?.spacing?.outer?.medium ? theme.spacing.outer.medium : '30px',
        large: theme?.spacing?.outer?.large ? theme.spacing.outer.large : '60px',
      },
      inner: theme?.spacing?.inner ? theme.spacing.inner : '40px',
    },
    style: {
      partnerHeader: {
        width: theme?.style?.partnerHeader?.width ? theme?.style?.partnerHeader?.width : '12',
      },
      buttons: {
        variant: theme?.style?.buttons?.variant ? theme?.style?.buttons?.variant : 'a',
      },
      pagination: {
        variant: theme?.style?.pagination?.variant ? theme?.style?.pagination?.variant : 'a',
      },
      feature: {
        variant: theme?.style?.feature?.variant ? theme?.style?.feature?.variant : 'a',
      },
      articleList: {
        buttonVariant: theme?.style?.articleList?.buttonVariant
          ? theme?.style?.articleList?.buttonVariant
          : 'secondary',
      },
      staffListing: {
        variant: theme?.style?.staffListing?.variant ? theme?.style?.staffListing?.variant : 'a',
      },
      navigation: {
        isStickyNav: theme?.style?.navigation?.isStickyNav
          ? theme?.style?.navigation?.isStickyNav
          : false,
        variant: theme?.style?.navigation?.variant ? theme?.style?.navigation?.variant : 'a',
      },
      image: {
        filter: theme?.style?.image?.filter ? theme?.style?.image?.filter : '',
      },
      keyline: {
        size: theme?.style?.keyline?.size ? theme?.style?.keyline?.size : '0',
      },
      footer: {
        variant: theme?.style?.footer?.variant ? theme.style.footer.variant : 'a',
      },
      radius: {
        general: theme?.style?.radius?.general ? theme.style.radius.general : '0px',
        button: theme?.style?.radius?.button ? theme.style.radius.button : '2px',
        avatar: theme?.style?.radius?.avatar ? theme.style.radius.avatar : '50%',
      },
      page: {
        maxWidth: theme?.style?.page?.maxWidth ? theme.style.page.maxWidth : '1200px',
      },
      darkWidgets: theme?.style?.darkWidgets ? theme?.style?.darkWidgets : false,
    },
  };

  return themeObj;
};
